import React from "react";

import { TableCreatorSubGroupGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";

import DealLaScKeyCommentListCreatorGroupShell from "./components/DealLaScKeyCommentListCreatorGroupShell/DealLaScKeyCommentListCreatorGroupShell";

import type { DealLaScSection } from "@/types/dealLaSc.types";

interface Props {
  groupTableKey: DealLaScSection;
  tableKey: string | null;
  groupShellList: TableCreatorSubGroupGroupShellList;
  groupTableIndex: number;
  tableIndex: number;
}

const DealLaScKeyCommentListCreatorTable = ({
  groupTableKey,
  tableKey,
  groupTableIndex,
  tableIndex,
  groupShellList,
}: Props) => {
  return (
    <>
      {groupShellList.map(
        ({ groupShellKey, subGroupShellList }, groupShellListIndex) => (
          <DealLaScKeyCommentListCreatorGroupShell
            key={`group-shell-${String(groupTableIndex)}-${String(
              tableIndex,
            )}-${String(groupShellListIndex)}`}
            subGroupShellList={subGroupShellList}
            groupTableKey={groupTableKey}
            groupTableIndex={groupTableIndex}
            tableKey={tableKey}
            tableIndex={tableIndex}
            groupShellKey={groupShellKey}
            groupShellIndex={groupShellListIndex}
          />
        ),
      )}
    </>
  );
};

export default DealLaScKeyCommentListCreatorTable;
